export function flattenDeep(arrayOfArrays) {
    return arrayOfArrays.reduce((prev, curr) => prev.concat(Array.isArray(curr) ? flattenDeep(curr) : curr), []);
}
